// React-Screen CCashboxPanel ("Kassenladen-Funktionen") - Strangler Phase 5.
// Runbook: tools/REACT-STRANGLER.md.
//
// ERSTER ENTSCHALTER SCREEN (Nutzer-Vorgabe 23.8.2026: keine Huellen mehr,
// verbindlich sind Pixelgleichheit und 100% Funktionalitaet, das DOM nicht).
// Vorher baute hier der Legacy-Widget-Baum das DOM (LYT_secondaryPanel.xml ->
// CFrame -> CPushPanel -> vier CPushButtons), React hielt nur die Huelle.
// Jetzt rendert React die Knoepfe selbst - ueber den gemeinsamen Baustein
// SecondaryPanel, den sich alle Sekundaer-Panels teilen (dort steht auch,
// warum Bild und Verhalten dabei gleich bleiben).
import { defineReactScreen } from '../bridge.js';
import { SecondaryPanel } from '../secondaryPanel.jsx';

function CashboxPanelScreen({ bridge }) {
  const t = bridge.t;

  // Dieselben vier Knoepfe wie das Legacy-makeFunctionButtons, nur als Daten
  // statt als CPushButton-Objekte.
  const knoepfe = [
    { text: t('BUTTONS', 'OPEN_CASHBOX'), handler: bridge.openDrawer },
    { text: t('BUTTONS', 'TAKE_OUT_MONEY'), handler: bridge.wait, param1: 'out' },
    { text: t('BUTTONS', 'PUT_IN_MONEY'), handler: bridge.wait, param1: 'in' },
    { text: t('BUTTONS', 'CHANGE_MONEY'), handler: bridge.wait, param1: 'change' },
  ];

  return (
    <SecondaryPanel bridge={bridge} spalten={4} knoepfe={knoepfe}
                    knopfStyle={{ backgroundRepeat: 'no-repeat' }} />
  );
}

export const CCashboxPanel = defineReactScreen({
  className: 'CCashboxPanel',
  addclass: 'secondaryPanel CCashboxPanel',
  htmlType: 'span',
  Screen: CashboxPanelScreen,
  // Die Methoden sind WOERTLICH die des Legacy-Screens (nur `this` -> bridge
  // und der Handler-Parameter vorangestellt); geaendert ist nur, WER das DOM
  // baut, nicht was passiert.
  methods: {
    // Aufrufer: CMainPOS.drawSubmenus.
    setMain(bridge, main) {
      bridge.Main = main;
    },
    setCallback(bridge) {
      POS.events.setOnClickEventCallback(bridge, bridge.disappear, true);
    },
    disappear(bridge, me) {
      me.Main.lastSubmenuId = 'CB';
      window.setTimeout(me.Main.restoreLastSubmenuId, 0, me.Main);
      document.getElementById(me.id).style.visibility = 'hidden';
    },
    // "Lade oeffnen"
    openDrawer(bridge) {
      POS.Cashbox.openDrawer();
    },
    // Entnahme / Einlage / Wechselgeld
    wait(bridge, component, parameters) {
      bridge.mode = parameters[1];

      var text;
      switch (bridge.mode) {
        case 'in':
          text = bridge.t('MESSAGES', 'PUT_IN_CASHBOX_LOAD');
          break;
        case 'out':
          text = bridge.t('MESSAGES', 'TAKE_OUT_CASHBOX_LOAD');
          break;
        case 'change':
          text = bridge.t('MESSAGES', 'CHANGE_CASHBOX_LOAD');
          break;
      }
      POS.hourGlass.show(text, bridge, bridge.start);
    },
    start(bridge) {
      bridge.Main.cmpBalance = bridge.Main.addChild(CPosBalancing);
      bridge.Main.cmpBalance.mode = bridge.mode;
      bridge.Main.cmpBalance.draw();
      bridge.Main.cmpBalance.inputs[0].field.input.setFocus();

      POS.hourGlass.hide();
    },
  },
});
